window.Popper = require('popper.js').default;
window.$ = window.jQuery = require('jquery');
require('bootstrap');
require('admin-lte/dist/js/adminlte');
require('jquery-chained/jquery.chained.remote');
require('moment');
require('moment/locale/el');

import bootbox from 'bootbox';
import 'bootstrap-daterangepicker';
import 'bootstrap-select';
import WebFontLoader from 'webfontloader';
import 'jquery-ui/ui/sortable';

import './product';
import './search';
import './x-editable';
import * as NestedSortable from './nested-sortable';
import * as OrderStatus from './order-status';
import * as Shipment from './order-shipment';
import * as ProductSearch from './product-search';

__webpack_public_path__ = $('#assets-url').attr('href');

WebFontLoader.load({
  google: { families: [ 'Roboto:400,700,500,300:greek,latin' ] }
});

$(() => {
  const token = $('meta[name="_token"]').attr('content');

  const $roots = $('.is-root');

  if ($roots.length) {
    NestedSortable.init($roots);
  }

  const $sortable = $('.js-sortable');

  if ($sortable.length) {
    $sortable.sortable({
      axis: 'y',
      cursor: 'ns-resize',
      handle: '.handle',
      items: '> tbody > tr',
      update () {
        $.post('seminars/position', {
          positions: $sortable.sortable('toArray', { attribute: 'data-id' }),
        });
      }
    });
  }

  const $statuses = $('.select-status');

  if ($statuses.length) {
    OrderStatus.init($statuses);
  }

  const $shipments = $('.js-shipment');

  if ($shipments.length) {
    Shipment.init($shipments);
  }

  // display loader when a button is clicked
  $('.btn-loader').on('click', (e) => {
    const $button = $(e.currentTarget).addClass('disabled');
    $button.find('.fa').addClass('d-none');
    $button.find('.spinner-border').removeClass('d-none');
  });

  bootbox.setDefaults({ locale: 'el' });

  $('.content').on('submit', '.confirm-delete', confirmForm('Είστε σίγουροι ότι θέλετε να διαγράψετε αυτό το στοιχείο;'));

  $('[data-confirm]').on('submit', confirmForm('Παρακαλώ επαληθεύστε αυτή την ενέργεια.'));

  // update on dropdown change
  $('.selectpicker').selectpicker({
    iconBase: 'fa-fw fa',
    tickIcon: 'fa-check',
    width: 'auto',
    multipleSeparator: '<br/>',
  }).on('change', (event) => {
    let $target = $(event.target);
    $.ajax({
      type: $target.data('method') || 'PUT',
      url: $target.data('url'),
      data: {
        [$target.attr('name')]: $target.val(),
      },
    });
  });

  $.ajaxSetup({
    headers: { 'X-CSRF-TOKEN': token },
  });

  $(document).ajaxError((event, jqXHR) => {
    let response = jqXHR.responseJSON;
    let message;

    console.error(response);

    switch (jqXHR.status) {
    case 422:
      message = Object.keys(response.errors).reduce((errors, error) => {
        errors.push(response.errors[error].join('\n'));
        return errors;
      }, []).join('\n');

      break;
    default:
      message = response.message;

      break;
    }

    bootbox.alert({
      title: 'Σφάλμα ' + jqXHR.status,
      message,
      className: 'modal modal-danger',
      buttons: {
        ok: {
          className: 'btn btn-default',
        }
      }
    });
  });

  // Switch

  $('.js-switch').on('change', (e) => {
    const $switch = $(e.target);
    const name = $switch.attr('name');
    const method = $switch.attr('method') || 'PATCH';
    const url = $switch.data('url');
    const states = $switch.data('states') || [0, 1];
    const state = $switch.is(':checked');
    const value = states[+state];

    if (!url) {
      return;
    }

    $.ajax({
      url: url,
      dataType: 'json',
      method: method,
      data: { [name]: value },
      success: () => {
        $switch.siblings('label').text((index, text) => text && value);
      }
    });
  });

  if ($('#variant').length) {
    ProductSearch.init();
  }

  $('.seminar-period-range').daterangepicker({
    locale: {
      applyLabel: 'Εντάξει',
      cancelLabel: 'Ακύρωση',
      format: 'DD/MM/YYYY',
      fromLabel: 'Από',
      toLabel: 'Μέχρι',
      customRangeLabel: 'Custom',
      firstDay: 1
    }
  });

  $('.seminar-session-range').daterangepicker({
    locale: {
      applyLabel: 'Εντάξει',
      cancelLabel: 'Ακύρωση',
      format: 'DD/MM/YYYY HH:mm',
      fromLabel: 'Από',
      toLabel: 'Μέχρι',
      customRangeLabel: 'Custom',
      firstDay: 1
    },
    timePicker: true,
    timePickerIncrement: 30,
    timePicker24Hour: true,
    timePickerSeconds: false
  });

  $('#ship_at').daterangepicker({
    singleDatePicker: true,
    autoUpdateInput: false,
    locale: {
      applyLabel: 'Εντάξει',
      cancelLabel: 'Ακύρωση',
      format: 'DD/MM/YYYY',
      fromLabel: 'Από',
      toLabel: 'Μέχρι',
      customRangeLabel: 'Custom',
      firstDay: 1
    }
  }).on('apply.daterangepicker', (ev, picker) => {
    $(picker.element).val(picker.startDate.format('DD/MM/YYYY'));
  });
});

/**
 * @param {string} msg
 */
function confirmForm(msg) {
  /**
   * @param {SubmitEvent} msg
   * @param {boolean} confirmed
   * @returns void
   */
  return (event, confirmed) => {
    if (confirmed) {
      return;
    }

    event.preventDefault();

    bootbox.confirm(msg, (result) => {
      if (result) {
        $(event.target).trigger('submit', true);
      }
    });
  };
}
